import { usePage } from "@inertiajs/react";
import CommunitiesLayout from "./Layout";
import ThreadDetailApp from "../../communities/pages/thread/App";

function Thread() {
  const { slug } = usePage().props;
  return <ThreadDetailApp params={{ id: slug }} />;
}
Thread.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>;
export default Thread;
